import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { primeFcmAtBoot } from "@/lib/fcmBootstrap";

// Status bar overlay is configured declaratively via capacitor.config.ts
// (plugins.StatusBar). Removing the synchronous Capacitor import here keeps
// the cold-start path lean so low-RAM Androids paint the inline boot splash
// (in index.html) before any plugin code runs.

// Remove the inline boot splash as soon as React's root is created. The
// splash itself lives in index.html so the user sees the logo immediately,
// even while the main JS bundle is still parsing.
const splash = document.getElementById("boot-splash");
if (splash) splash.remove();

createRoot(document.getElementById("root")!).render(<App />);

// Prime FCM at app boot (Android-only, no-op elsewhere) so the very first
// login already has a registration token to send to driver-login.verify_otp.
// Fire-and-forget; never throws.
try { primeFcmAtBoot(); } catch { /* ignore */ }
